export default __webpack_public_path__ + "d9c199b3e3e469cc5713d2b37494dbf7.svg";